<template>
  <div class="transaction-details" v-loading="isLoading">
    <el-row :gutter="18">
      <el-col :md="24" class="mb-3">
        <el-card class="box-card" :body-style="{ padding: '20px 20px 2px 20px' }">
          <div slot="header" class="clearfix detail-header">
            <i class="fa fa-inbox"></i>Transaction
            <el-button type="primary" icon="fa fa-pencil-alt" @click="editTransaction" v-if="isAdmin">Edit</el-button>
          </div>
          <el-row :gutter="18" justify="start">
            <el-col :sm="12" :lg="6">
              <static-field label="Account" :value="transactionType"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Office" :value="office ? office.efin : ''"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Amount" :value="transaction.amount"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Type" :value="prettyPaymentType(transaction.paymentType)"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="User" :value="usersName"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Void" :value="convertToYesOrNo(transaction.void)"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Edited by Admin" :value="convertToYesOrNo(transaction.adminEdit)"></static-field>
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Date" :value="transaction.date"></static-field>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- RELATED ENTITY DEPOSIT -->
    <template v-if="relatedEntity && relatedEntity.deposit">
      <el-row :gutter="18">
        <el-col :md="24" class="mb-3">
          <el-card class="box-card" :body-style="{ padding: '20px 20px 2px 20px' }">
            <div slot="header" class="clearfix detail-header">
              Deposit
              <el-button type="primary" icon="fa fa-pencil-alt" @click="editDeposit" v-if="isAdmin">Edit</el-button>
            </div>
            <el-row :gutter="18" justify="start">
              <el-col :sm="12" :lg="6">
                <static-field label="Check Number" :value="relatedEntity.deposit.checkNumber"></static-field>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog title="Edit Deposit" :visible.sync="editDepositDialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="400px" v-if="isAdmin || isAccountant">
        <edit-deposit-dialog @close="editDepositDialogVisible = false" :deposit="relatedEntity.deposit" @depositUpdated="onDepositUpdated"></edit-deposit-dialog>
      </el-dialog>
    </template>
    <el-dialog title="Edit Transaction" :visible.sync="editTransactionDialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="400px" v-if="isAdmin">
      <transaction-dialog @close="editTransactionDialogVisible = false" :transaction="transaction" @transactionUpdated="onTransactionUpdated"></transaction-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/api';
import Transaction from '@/model/Transaction';
import RelatedEntity from '@/model/RelatedEntity';
import Office from '@/model/Office';
import { TRANSACTION_TYPE_DESCRIPTION_MAP } from '@/enum/TransactionType';
import { PAYMENT_TYPE_DESCRIPTION_MAP } from '@/enum/PaymentType';
import StaticField from '@/components/widgets/StaticField.vue';
import TransactionDialog from '@/components/dialog-content/Transaction.vue';
import EditDepositDialog from '@/components/dialog-content/EditDeposit.vue';

export default {
  name: 'TransactionDetail',
  data() {
    return {
      isLoading: false,
      transaction: new Transaction(),
      editTransactionDialogVisible: false,
      editDepositDialogVisible: false,
      relatedEntity: new RelatedEntity(),
    };
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    editTransaction() {
      this.editTransactionDialogVisible = true;
    },
    editDeposit() {
      this.editDepositDialogVisible = true;
    },
    onTransactionUpdated(transaction) {
      this.transaction = new Transaction(transaction);
    },
    onDepositUpdated(deposit) {
      this.relatedEntity.deposit = deposit;
    },
    convertToYesOrNo(val) {
      return val ? 'Yes' : 'No';
    },
    prettyPaymentType(paymentType) {
      return PAYMENT_TYPE_DESCRIPTION_MAP[paymentType];
    },
  },
  computed: {
    ...mapGetters('User', ['isAdmin', 'isAccountant']),
    ...mapGetters('Lookup', [
      'officeMap',
    ]),
    office() {
      if (this.transaction.officeId !== undefined) {
        return this.officeMap[this.transaction.officeId];
      }
      return new Office();
    },
    transactionType() {
      if (this.transaction.typeId === undefined) return '';
      return TRANSACTION_TYPE_DESCRIPTION_MAP[this.transaction.typeId];
    },
    usersName() {
      if (this.transaction.user === undefined) return '';

      return this.transaction.user.fullName;
    },
  },
  mounted() {
    this.getOffices();
    const transactionId = this.$route.params.transactionId;
    if (this.$route.params && transactionId) {
      this.isLoading = true;
      api.transaction.get(transactionId).then((response) => {
        this.transaction = { ...Transaction, ...response.data };
      }).finally(() => {
        this.isLoading = false;
      });

      api.transaction.getRelatedEntity(transactionId).then((response) => {
        if (response && response.data) {
          this.relatedEntity = new RelatedEntity(response.data);
        }
      });
    }
  },
  components: {
    EditDepositDialog,
    StaticField,
    TransactionDialog,
  },
};

</script>

<style lang="scss" scoped>
.detail-header {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;

  button {
    float: right;
    padding: 5px 5px;
  }
}
</style>
